import { render, staticRenderFns } from "./planCount.vue?vue&type=template&id=68225590"
import script from "./planCount.vue?vue&type=script&lang=js"
export * from "./planCount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports